<div [formGroup]="form" class="display-flex flex-column grid-gap-24">
  <div class="display-flex grid-gap-24 align-items-start">
    <div class="flex-1">
      <app-radio-button-dropdown
        [attrDisable]="false"
        [displaySkeleton]="false"
        [containerCss]="'w-100'"
        [label]="'Inspection'"
        [customListItemTemplate]="inspectionTypeItem"
        [items]="inspectionTypes"
        [allowSearch]="inspectionTypes?.length > 7"
        formControlName="inspectionTemplateId"
        [labelRequired]="true"
        [markAsInvalid]="formPosted && form.controls.inspectionTemplateId.invalid"
        [showValidationError]="false"
        [attrPlaceholder]="'Select inspection'"
        [attrAppendTo]="'body'"></app-radio-button-dropdown>
    </div>
  </div>
  <div class="display-flex grid-gap-24 align-items-start">
    <div class="flex-70">
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        class="flex-grow-1"
        [containerCss]="'w-100'"
        [items]="userProperties"
        [allowSearch]="userProperties?.length > 7"
        [attrDisable]="!userProperties?.length || (selectPropertiesLoading$ | async) || !!diligenceId"
        [label]="'Property'"
        formControlName="propertyId"
        [allowClear]="false"
        [showValidationError]="false"
        [markAsInvalid]="formPosted && form.controls.propertyId.invalid"
        [attrPlaceholder]="'Select property'"
        [labelRequired]="true"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
    <div class="flex-30">
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        *ngIf="
          _inspectionType !== InspectionScheduleType.Repeating && _inspectionType !== InspectionScheduleType.Standard
        "
        [containerCss]="'w-100'"
        [containerWidthCss]="'w-100'"
        [items]="userUnits"
        [allowSearch]="userUnits?.length > 7"
        [attrDisable]="(!userUnits?.length && !propertyId.value) || (propertyUnitsLoading$ | async)"
        [label]="'Unit'"
        formControlName="unitId"
        [allowClear]="true"
        [autoSortList]="false"
        [markAsInvalid]="formPosted && form.controls.unitId.invalid"
        [showValidationError]="false"
        [attrPlaceholder]="propertyId.value ? 'Select unit' : 'Select property first'"
        [labelRequired]="true"
        [listLoading]="propertyUnitsLoading$ | async"
        attrAppendTo="body"></app-radio-button-dropdown>
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        *ngIf="
          _inspectionType === InspectionScheduleType.Repeating || _inspectionType === InspectionScheduleType.Standard
        "
        [containerCss]="'w-100'"
        [containerWidthCss]="'w-100'"
        [items]="userUnits"
        [allowSearch]="userUnits?.length > 7"
        [attrDisable]="(!userUnits?.length && !propertyId.value) || (propertyUnitsLoading$ | async)"
        [label]="'Units'"
        formControlName="bulkUnitIds"
        [allowClear]="true"
        [autoSortList]="false"
        [multiSelect]="true"
        [markAsInvalid]="formPosted && form.controls.bulkUnitIds.invalid"
        [showValidationError]="false"
        [attrPlaceholder]="propertyId.value ? 'Select units' : 'Select property first'"
        [labelRequired]="true"
        [listLoading]="propertyUnitsLoading$ | async"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
  </div>
  <ng-container
    *ngIf="
      _inspectionType !== InspectionScheduleType.Standard && _inspectionType !== InspectionScheduleType.Resident;
      else defaultView
    ">
    <ng-container
      *ngTemplateOutlet="
        rowTemplate;
        context: { firstComponent: dueDateComponent, secondComponent: expiresComponent }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="
        rowDoubleTemplate;
        context: { firstComponent: repeatsComponent, secondComponent: untilComponent }
      "></ng-container>
  </ng-container>

  <ng-template #defaultView>
    <ng-container
      *ngTemplateOutlet="
        combinedRowTemplate;
        context: {
          firstComponent: dueDateComponent,
          secondComponent: repeatsComponent,
          thirdComponent: expiresComponent
        }
      "></ng-container>
  </ng-template>

  <ng-template #rowTemplate let-firstComponent="firstComponent" let-secondComponent="secondComponent">
    <div class="display-flex grid-gap-24">
      <div class="flex-40">
        <ng-container *ngTemplateOutlet="firstComponent"></ng-container>
      </div>
      <div class="flex-30">
        <ng-container *ngTemplateOutlet="secondComponent"></ng-container>
      </div>
      <div class="flex-30"></div>
    </div>
  </ng-template>
  <ng-template #rowDoubleTemplate let-firstComponent="firstComponent" let-secondComponent="secondComponent">
    <div class="display-flex grid-gap-24">
      <div class="flex-70">
        <ng-container *ngTemplateOutlet="firstComponent"></ng-container>
      </div>
      <div class="flex-30">
        <ng-container *ngTemplateOutlet="secondComponent"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template
    #combinedRowTemplate
    let-firstComponent="firstComponent"
    let-secondComponent="secondComponent"
    let-thirdComponent="thirdComponent">
    <div class="display-flex grid-gap-24">
      <div class="flex-30">
        <ng-container *ngTemplateOutlet="firstComponent"></ng-container>
      </div>
      <div class="flex-40">
        <ng-container *ngTemplateOutlet="secondComponent"></ng-container>
      </div>
      <div class="flex-30">
        <ng-container *ngTemplateOutlet="thirdComponent"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #dueDateComponent>
    <app-date-dropdown
      [displaySkeleton]="false"
      [containerCss]="'w-100'"
      [buttonCss]="'w-100'"
      [valueCss]="'text-color dark pre-option'"
      [label]="'Due'"
      formControlName="dueDate"
      [min]="today"
      [markAsInvalid]="formPosted && form.controls.dueDate.invalid"
      [showValidationError]="false"
      [attrPlaceholder]="'Select date'"
      [labelRequired]="true"></app-date-dropdown>
  </ng-template>

  <ng-template #expiresComponent>
    <app-radio-button-dropdown
      [displaySkeleton]="false"
      class="flex-grow-1"
      [items]="expireOptions"
      [containerCss]="'w-100'"
      [label]="'Expires'"
      formControlName="autoExpiredOn"
      [allowClear]="false"
      [allowSearch]="expireOptions?.length > 7"
      [autoSortList]="false"
      [showValidationError]="false"
      [labelRequired]="false"
      [markAsInvalid]="formPosted && form.controls.autoExpiredOn.invalid"
      [attrPlaceholder]="'Select value'"
      attrAppendTo="body"></app-radio-button-dropdown>
  </ng-template>

  <ng-template #repeatsComponent>
    <app-radio-button-dropdown
      [displaySkeleton]="false"
      class="flex-grow-1"
      [containerCss]="'w-100'"
      [items]="recurrenceOptions"
      [allowSearch]="recurrenceOptions?.length > 7"
      [label]="'Repeats'"
      formControlName="recurrencePeriod"
      [allowClear]="false"
      [showValueTooltip]="true"
      [autoSortList]="false"
      [showValidationError]="false"
      [labelRequired]="false"
      [markAsInvalid]="formPosted && form.controls.recurrencePeriod.invalid"
      [attrPlaceholder]="'Does not repeat'"
      attrAppendTo="body"></app-radio-button-dropdown>
  </ng-template>

  <ng-template #untilComponent>
    <app-date-dropdown
      [displaySkeleton]="false"
      [containerCss]="'w-100'"
      [buttonCss]="'w-100'"
      [valueCss]="'text-color dark pre-option'"
      [label]="'Until'"
      formControlName="endDate"
      [min]="today"
      [markAsInvalid]="formPosted && form.controls.endDate.invalid"
      [showValidationError]="false"
      [required]="false"
      [attrPlaceholder]="endDatePlaceholder"></app-date-dropdown>
  </ng-template>

  <div class="display-flex flex-column grid-gap-8">
    <div class="display-flex grid-gap-24">
      <div class="flex-55 display-flex grid-gap-24">
        <div class="flex-1">
          <div class="display-flex flex-column grid-gap-24">
            <app-user-select-dropdown
              [displaySkeleton]="false"
              [containerCss]="'w-100'"
              [label]="isResident ? 'Resident' : 'Assignee'"
              labelCss="'nowrap"
              [allowClear]="true"
              [labelRequired]="false"
              [displayNameAsLabel]="true"
              formControlName="assignee"
              [users]="usersAssigneeVisible$ | async"
              [isResident]="isResident"
              [allowSearch]="(usersAssigneeVisible$ | async)?.length > 7"
              [attrPlaceholder]="
                (isDisableAssignee$ | async)
                  ? !!propertyId.value &&
                    ((_inspectionType === InspectionScheduleType.Resident && !!form.controls.unitId.value) ||
                      (_inspectionType !== InspectionScheduleType.Resident && !!bulkUnitIds.value?.length))
                    ? 'No available resident'
                    : 'Please select Property & Unit'
                  : 'Unassigned'
              "
              [attrDisable]="isDisableAssignee$ | async"
              [showChevron]="true"
              [defaultOptions]="defaultAssigneeOptions$ | async"
              [markAsInvalid]="formPosted && form.controls.assignee.invalid"
              [showValidationError]="false"
              [attrAppendTo]="'body'"></app-user-select-dropdown>
          </div>
        </div>
        <div style="display: none">
          <mat-checkbox class="notify" color="primary" formControlName="notifyAssignee">Notify</mat-checkbox>
        </div>
        <!--<div class="display-flex flex-column" *ngIf="(usersAssigneeVisible$ | async)?.length === 0">
          <div class="notify notify-placeholder skeleton-loader"></div>
        </div> -->
      </div>
      <div class="flex-45">
        <app-radio-button-dropdown
          [displaySkeleton]="false"
          class="flex-grow-1"
          [containerCss]="'w-100'"
          [items]="notifyOptions"
          [label]="'Notify on'"
          formControlName="createOrNotifyOn"
          [allowClear]="false"
          [allowSearch]="notifyOptions?.length > 7"
          [autoSortList]="false"
          [showValidationError]="false"
          [labelRequired]="false"
          [markAsInvalid]="formPosted && form.controls.createOrNotifyOn.invalid"
          [attrPlaceholder]="'On due date'"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>
    </div>
    <div *ngIf="assignee.value">
      <app-notify-message
        [showCreateMessage]="false"
        [assigneeName]="assigneeName$ | async"
        [notifyAssignee]="notifyAssignee.value"
        [createOrNotifyOn]="createOrNotifyOn.value"
        [customNotifyOn]="customNotifyOn.value"
        [remindOn]="remindOn.value"
        [thenRemindOn]="thenRemindOn.value"
        [until]="until.value"
        (onOpenDialog)="openCustomNotificationsDialog()"></app-notify-message>
    </div>
  </div>

  <div class="display-flex grid-gap-24">
    <div class="flex-1">
      <div class="display-flex grid-gap-24 user-select-max-width">
        <app-radio-button-dropdown
          [displaySkeleton]="false"
          class="flex-1"
          [items]="reviewRequiredPolicyList"
          [containerCss]="'w-100'"
          [containerWidthCss]="'w-100'"
          [label]="'Review required'"
          formControlName="reviewRequired"
          [allowClear]="false"
          [autoSortList]="true"
          [isSmallFont]="true"
          [applySmallFontForCollapsed]="false"
          [withNoFadeOption]="true"
          [labelRequired]="false"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>
    </div>
    <div class="display-flex flex-column">
      <mat-checkbox class="notify" color="primary" formControlName="notifyWhenReviewRequired">Notify</mat-checkbox>
    </div>
    <div class="flex-30">
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        class="flex-1"
        [items]="getUsersOptionsBase$ | async"
        [containerCss]="'w-100'"
        [containerWidthCss]="'w-100'"
        [label]="'Assignee for Review'"
        itemPlaceholder="Select assignee"
        formControlName="reviewRequiredByUserId"
        [allowClear]="true"
        [allowSearch]="(getUsersOptionsBase$ | async)?.length > 7"
        [autoSortList]="true"
        [attrPlaceholder]="'Select assignee'"
        [markAsInvalid]="formPosted && form.controls.reviewRequiredByUserId.invalid"
        [showValidationError]="false"
        [labelRequired]="form.get('reviewRequired').value !== reviewRequiredPolicy.NotRequired"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
  </div>
  <div class="display-flex grid-gap-24">
    <div class="flex-55">
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        class="flex-1"
        [items]="userRadioButtonOptions$ | async"
        [multiSelect]="true"
        [containerCss]="'w-100'"
        [containerWidthCss]="'w-100'"
        [label]="'Notify when inspection completed'"
        itemPlaceholder="recipient"
        formControlName="notifyWhenDoneUserIds"
        [allowClear]="true"
        [allowSearch]="(userRadioButtonOptions$ | async)?.length > 7"
        [autoSortList]="true"
        [showValidationError]="true"
        [labelRequired]="false"
        [attrPlaceholder]="'Who would you like to notify?'"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
    <div class="flex-45">
      <app-radio-button-dropdown
        [displaySkeleton]="false"
        class="flex-1"
        [items]="userRadioButtonOptions$ | async"
        [multiSelect]="true"
        [containerCss]="'w-100'"
        [containerWidthCss]="'w-100'"
        [label]="'Notify when completed with issues'"
        itemPlaceholder="recipient"
        formControlName="notifyWhenNonDefaultOrNASelectedUserIds"
        [allowClear]="true"
        [allowSearch]="(userRadioButtonOptions$ | async)?.length > 7"
        [autoSortList]="true"
        [showValidationError]="true"
        [labelRequired]="false"
        [attrPlaceholder]="'Who would you like to notify?'"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
  </div>
  <div class="display-flex grid-gap-24 appointment">
    <div class="flex-70 display-flex grid-gap-24">
      <div class="flex-1">
        <app-radio-button-dropdown
          [displaySkeleton]="false"
          formControlName="scheduleAppointmentIsRequired"
          [items]="scheduleAppointmentIsRequiredOptions"
          [label]="'Schedule an Appointment'"
          [containerCss]="'w-100'"
          [containerWidthCss]="'w-100'"
          [allowClear]="false"
          [allowSearch]="false"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>

      <div class="flex-1">
        <app-date-dropdown
          [displaySkeleton]="false"
          [containerCss]="'w-100'"
          [buttonCss]="'w-100'"
          [valueCss]="'text-color dark pre-option'"
          [label]="'Appointment Date'"
          formControlName="appointmentDate"
          [min]="today"
          [markAsInvalid]="formPosted && form.controls.endDate.invalid"
          [showValidationError]="false"
          [required]="false"
          [clearable]="true"
          [attrPlaceholder]="'Choose date'"></app-date-dropdown>
      </div>
    </div>

    <div class="plus-minus-column-height flex-30 display-flex grid-gap-24">
      <div class="flex-1" *ngIf="isShowAppointment">
        <app-radio-button-dropdown
          [displaySkeleton]="false"
          formControlName="appointmentTime"
          [label]="'Appointment Time'"
          [allowClear]="false"
          [allowSearch]="false"
          [autoSortList]="false"
          [skipNormalizeOnChange]="true"
          [containerCss]="'w-100'"
          [containerWidthCss]="'w-100'"
          class="ml-18f flex-1"
          [items]="appointments"
          [isSmallFont]="true"
          [markAsInvalid]="form.get('appointmentConfirmed').value && form.get('appointmentTime').invalid"
          [showValidationError]="false"
          [attrPlaceholder]="'Select time'"
          attrAppendTo="body"></app-radio-button-dropdown>
      </div>

      <div class="plus-icon display-flex cursor-pointer">
        <app-icon
          (click)="onHandleToogleNotes()"
          [iconWidth]="24"
          [iconHeight]="24"
          [svg]="isDisplayedNotes ? EIcon.MINUS_ROUNED : EIcon.PLUS_ROUNED"></app-icon>
      </div>
    </div>
  </div>

  <div>
    <div class="display-flex flex-column">
      <mat-checkbox class="notify mt-auto" color="primary" formControlName="appointmentConfirmed">
        Confirmed with the resident
      </mat-checkbox>
    </div>
  </div>

  <div *ngIf="isDisplayedNotes">
    <app-input-area
      [displaySkeleton]="false"
      id="inspection-appointment-notes"
      formControlName="appointmentNotes"
      class="w-100"
      [inputCss]="'hp-92'"
      [containerCss]="'fill body-small'"
      [attrPlaceholder]="'Write your notes'"
      [displayCounter]="true"
      [showValidationError]="true"
      [maxCounter]="200"></app-input-area>
  </div>
</div>

<ng-template #inspectionTypeItem let-item="item">
  <div class="display-flex flex-auto grid-gap-8 flex-column" [class.min-h-50]="item?.disabled || item?.description">
    <div class="display-flex align-items-start">
      <h5 style="margin: 0" class="text-size s16 text-weight w700">{{ item?.label }}</h5>
    </div>
    <div
      *ngIf="item?.disabled || item?.description"
      class="flex-auto display-flex align-items-start"
      style="white-space: initial">
      <div class="text-color orange text-size s14 text-weight w600" *ngIf="item?.disabled">Coming soon!</div>
      <span class="text-size s14" *ngIf="!item?.disabled">{{ item?.description }}</span>
    </div>
  </div>
</ng-template>
